/**
 * Resize an iframe to 100% or the size of the iframe (based on a break point)
 * This code is being re-used between the US terms page and the GB credit agreement
 * @param {object} win - The global window object
 * @param {element} iframe - The iframe dom element to be resized
 * @param {number} extraHeight - Some extra buffer space/height
 * @param {number} longScrollBreakpointWidth - The mobile breakpoint
 * @returns {string} - The new iframe height (either '100%' or a px value)
 */
export const getIframeHeight = (win, iframe, extraHeight = 0, longScrollBreakpointWidth = Infinity) => {
    let newHeight = '100%';
    if (iframe && iframe.contentWindow) {
        const iframeOffsetHeight = `${iframe.contentWindow.document.body.offsetHeight + extraHeight}px`;
        if (win.innerWidth < longScrollBreakpointWidth) {
            newHeight = iframeOffsetHeight;
        }
    }
    return newHeight;
};
